import { GNAT, WASP, FLEA } from '../types/ship/ship-type';

// Ship types
export const WEAKEST_SHIP = FLEA;
export const INITIAL_SHIP_TYPE = GNAT;
export const STRONGEST_SHIP = WASP;
export const MAX_TRAVEL_RANGE = 20;
